import React, { useEffect, useState } from 'react';
import api from '../api';
import StatusBadge from './statusBadge';

export default function History({ role }) {
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState('');
  const [customer, setCustomer] = useState('');

  useEffect(() => { api.get('/api/orders?archive=Archived').then(r => setOrders(r.data || [])).catch(() => setOrders([])); }, []);

  const customers = [...new Set(orders.map(o => o.customer_name).filter(Boolean))];
  const filtered = orders.filter(o => {
    if (search && !`${o.part_number} ${o.po_number}`.toLowerCase().includes(search.toLowerCase())) return false;
    if (customer && o.customer_name !== customer) return false;
    return true;
  });
  const showPricing = role !== 'shop_floor';

  return (
    <div>
      <h2>History (Archived)</h2>
      <div className="filterbar">
        <input placeholder="Search part / PO…" value={search} onChange={e => setSearch(e.target.value)} />
        <select value={customer} onChange={e => setCustomer(e.target.value)}>
          <option value="">All Customers</option>{customers.map(c => <option key={c}>{c}</option>)}
        </select>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <table>
          <thead><tr>
            <th>Part Number</th><th>Customer</th><th>PO #</th><th>Machine</th><th>Due Date</th>
            <th>Qty Ordered</th><th>Qty Shipped</th><th>Material Status</th><th>Status</th>{showPricing && <th>Total Value</th>}
          </tr></thead>
          <tbody>
            {filtered.map(o => (
              <tr key={o.id}>
                <td>{o.part_number}</td><td>{o.customer_name}</td><td>{o.po_number}</td><td>{o.machine_name}</td><td>{o.due_date}</td>
                <td>{o.qty_ordered}</td><td>{o.qty_shipped}</td><td>{o.raw_material_status}</td>
                <td><StatusBadge status={o.status} /></td>
                {showPricing && <td>${(Number(o.qty_ordered || 0) * Number(o.sales_price || 0)).toFixed(2)}</td>}
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={showPricing ? 10 : 9} style={{ textAlign: 'center', color: '#888', padding: 24 }}>No archived orders.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
